import React from "react";
import EtHeader from "@/components/navigation/EtHeader";
import EtFooter from "@/components/navigation/EtFooter";

// Client-specific sections (to be created)
import EtClientsHero from "@/components/sections/clients/EtClientsHero";
import EtClientsSegments from "@/components/sections/clients/EtClientsSegments";
import EtClientsCaseStudies from "@/components/sections/clients/EtClientsCaseStudies";
import EtClientsCTA from "@/components/sections/clients/EtClientsCTA";

// 17 Oct 2025
import EtClientsStates from "@/components/sections/clients/EtClientsStates";

// 18 Oct 2025
import EtClientsMindPatterns from "@/components/sections/clients/EtClientsMindPatterns";

// 25 Oct 2025
import EtTestimonials from "@/components/sections/EtTestimonials";

// 20 Nov 2025
import {useState, useEffect} from "react"

const EtClients = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Updated - 17 Oct 2025 - Added EtClientsStates
  // Updated - 18 Oct 2025 - Added EtClientsMindPatterns
  // Updated - 25 Oct 2025 - Added EtTestimonials
  // Updated - 20 Nov 2025 - scroll control

 // 1 - Scroll to top on reload - 20 Nov 2025
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 100); 
        }
      }
    }
  }, []);

  return (
    <div className="font-poppins">
      {/* Global Header */}
      <EtHeader variant="eternity" />

      {/* Page Sections */}
      <EtClientsHero />
      <EtClientsSegments />
      <EtClientsStates />
      <EtClientsMindPatterns />
      <EtTestimonials />
      {/* <EtClientsCaseStudies /> */}
      <EtClientsCTA />

      {/* Global Footer */}
      <EtFooter />
    </div>
  );
};

export default EtClients;
